import { Subject } from 'rxjs';

export const SESSION_TIMEOUT_CHECK_INTERVAL = 600000;
export const SESSION_TIMEOUT_SUBJECT: Subject<boolean> = new Subject<boolean>();
export const PAGE_COUNT = 7;
